import { ref } from "vue";
import { fetchFeatureFlags } from "../services/cms";

// List of static feature flags
const flags = ["PORTAL_NOTIFICATIONS"] as const;

const featureFlagsState = Object.fromEntries(flags.map((flag) => [flag, ref(false)])) as Record<
    (typeof flags)[number],
    ReturnType<typeof ref>
>;

// Hydrate feature flags from API
export async function initializeFeatureFlags() {
    try {
        const response = await fetchFeatureFlags();
        const featureFlags = response.data?.data || [];
        if (import.meta.env.VITE_BUILD_ENV === "production") {
            for (const flag of flags) {
                featureFlagsState[flag].value =
                    featureFlags.find((f: any) => f.attributes.Feature === flag)?.attributes
                        .Production ?? false;
            }
        } else {
            for (const flag of flags) {
                featureFlagsState[flag].value = true;
            }
        }
    } catch (error) {
        // fallback: set all flags to true in case of error
        for (const flag of flags) {
            featureFlagsState[flag].value = true;
        }
    }
}

export function useFeatureFlags() {
    return featureFlagsState;
}
